import { LinkedError, checkAxiosResponse, handleAxiosError } from '@mst-fe/shared';
import axios from 'axios';

import { observeEndpoint } from '../../../services/endpoint-observer';
import { axiosOptions } from '../../../services/requests';

export interface NotificationItem {
  id: number;
  userSubject: string;
  referencedEntity?: string | undefined;
  awsNotificationId?: string | undefined;
  criticality: number;
  isDismissed?: number;
  dismissedAt?: Date | undefined;
  title: string;
  description: string | undefined;
  jsonData?: string | undefined;
  createdAt: Date;
  updatedAt: Date;
  isSeen: boolean;
  seenUnsync?: boolean;
  referencedAction?: string;
}

export class NotificationsApi {
  async getOutstandingNotificationsAfterId(notificationId: number) {
    // protect against injection!
    return await checkAxiosResponse(
      axios.get<NotificationItem[]>(`/api/zoe/notifications/outstanding?id=${parseInt(notificationId.toString())}`, axiosOptions())
    );
  }

  initNotificationsInterval(cb: (value: NotificationItem[]) => void) {
    return observeEndpoint<NotificationItem[]>(`/api/zoe/notifications/sse`, cb);
  }

  async setNotificationDismissed(id?: number): Promise<boolean> {
    const responseOrError = await handleAxiosError(
      axios.post<{ ok: true }>(`/api/zoe/notifications/set-read`, id ? { id } : null, { ...axiosOptions(), timeout: 10 * 1000 })
    );

    if (responseOrError instanceof LinkedError) {
      return false;
    }

    return responseOrError.ok;
  }

  async setNotificationsSeen(ids: number[]): Promise<boolean> {
    const responseOrError = await handleAxiosError(
      axios.post<{ ok: true }>(`/api/zoe/notifications/set-seen`, { ids }, { ...axiosOptions() })
    );

    if (responseOrError instanceof LinkedError) {
      return false;
    }

    return responseOrError.ok;
  }
}
